import React, {PureComponent} from 'react';
import {Alert} from 'reactstrap';
import PropTypes from 'prop-types';
import CheckBox from "./CheckBox";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import * as http from "../modules/http";
import {fetchUtilsDataIfNeeded} from '../redux/actions/UtilsActions'


export class ThreeQuesWarning extends PureComponent {
    static propTypes = {
        color: PropTypes.string,
        icon: PropTypes.bool,
        className: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {
            visible: true,
            warning1: false,
            warning2: false,
            warning3: false,
        };
    }

    updateWarning = (val, num) => {

        let data = {};

        switch(num) {
            case 1:
                data.war1 = val;
                data.war2 = this.state.warning2;
                data.war3 = this.state.warning3;

                this.setState({warning1: val});
                break;

            case 2:
                data.war1 = this.state.warning1;
                data.war2 = val;
                data.war3 = this.state.warning3;

                this.setState({warning2: val});
                break;

            case 3:
                data.war1 = this.state.warning1;
                data.war2 = this.state.warning2;
                data.war3 = val;

                this.setState({warning3: val});
                break;

            default:
                break;
        }

        http.postToServer(
            'clear/warning',
            data,
            (response) => {

                this.props.dispatch(fetchUtilsDataIfNeeded(true));

            },
            (response) => {
                console.log('clearWarning');
            }
        );

    };


    render() {

        //reshow the message in case that the message ID was changed
        if(this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.isWarning) {
            if(this.props.utilsData.data.isWarning.war1 !== this.state.warning1 ||
                this.props.utilsData.data.isWarning.war2 !== this.state.warning2 ||
                this.props.utilsData.data.isWarning.war3 !== this.state.warning3) {

                this.setState({warning1: this.props.utilsData.data.isWarning.war1,
                    warning2: this.props.utilsData.data.isWarning.war2,
                    warning3: this.props.utilsData.data.isWarning.war3});
            }
        }


        if (this.state.visible) {
            return (
                <span>
                    <style>
                    {`
                        .alert-secondary {
                        background-color: #E6E6FA;
                        border-color: #9400D3;
                        }
                    `}
                    </style>
                    <Alert style={{width: "100%"}} color={this.props.color} className={this.props.className}
                           isOpen={this.state.visible}>
                        <div className='alert__content'>
                            <h4 style={{
                                textAlign: 'left',
                                color: '#DC143C',
                                fontWeight: 'bold'
                            }}>?מכרת 3 הוט גולדפון</h4>
                            <span style={{display: "inline-block", height: 10}}></span>
                            <div className='form__form-group'>
                                <div className='form__form-group-field'>
                                    <CheckBox
                                        color='#FFFFF0'
                                        name='warning1'
                                        value={this.state.warning1}
                                        label='מכרתי 1'
                                        onChange={(e) => this.updateWarning(e, 1)}
                                    />
                                </div>

                                <div className='form__form-group-field'>
                                    <CheckBox
                                        color='#FFFFF0'
                                        name='warning2'
                                        value={this.state.warning2}
                                        label='מכרתי 2'
                                        onChange={(e) => this.updateWarning(e, 2)}
                                    />
                                </div>

                                <div className='form__form-group-field'>
                                    <CheckBox
                                        color='#FFFFF0'
                                        name='warning3'
                                        value={this.state.warning3}
                                        label='מכרתי 3'
                                        onChange={(e) => this.updateWarning(e, 3)}
                                    />
                                </div>
                            </div>
                        </div>
                    </Alert>
                </span>
            );
        }

        return <span/>;
    }
}

const mapStateToProps = (state) => {
    return {
        utilsData: state.utilsData,
    };
};

export default withRouter(connect(mapStateToProps)(ThreeQuesWarning))